import React from "react";
import "../Team/Team.css";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const teamMembers = [
  { name: "Adv. Rajesh Sharma", title: "Managing Partner", image: "demo.webp" },
  { name: "Adv. Priya Kapoor", title: "Senior Partner", image: "demo2.webp" },
  { name: "Adv. Anil Mehta", title: "Partner", image: "demo.webp" },
  { name: "Adv. Sneha Iyer", title: "Partner", image: "demo2.webp" },
  { name: "Adv. Vikram Singh", title: "Associate Partner", image: "demo.webp" },
  { name: "Adv. Nisha Patel", title: "Associate Partner", image: "demo2.webp" },
  {
    name: "Adv. Karan Malhotra",
    title: "Senior Associate",
    image: "demo.webp",
  },
  { name: "Adv. Meera Joshi", title: "Senior Associate", image: "demo2.webp" },
];

const TeamSection = () => {
  const [index, setIndex] = React.useState(0);
  const visibleCount = 4;

  const nextSlide = () => {
    setIndex((prevIndex) =>
      prevIndex + visibleCount >= teamMembers.length
        ? 0
        : prevIndex + visibleCount,
    );
  };

  const prevSlide = () => {
    setIndex((prevIndex) =>
      prevIndex - visibleCount < 0
        ? Math.max(teamMembers.length - visibleCount, 0)
        : prevIndex - visibleCount,
    );
  };

  const visibleMembers = teamMembers.slice(index, index + visibleCount);

  return (
    <section className="team-section">
      <div className="team-heading">
        <div className="heading-left">
          <hr />
          <p>LEGAL EXPERTISE</p>
          <h1>Your Defenders</h1>
        </div>
        <div className="heading-right">OUR TEAM</div>
      </div>

      <div className="team-carousel">
        {visibleMembers.map((member, i) => (
          <div key={i} className="team-card active">
            <img src={member.image} alt={member.name} />
            <h3>{member.name}</h3>
            <p>{member.title}</p>
            <div className="social-icons">
              <FaFacebookF />
              <FaLinkedinIn />
              <FaInstagram />
              <FaXTwitter />
            </div>
          </div>
        ))}
      </div>

      <div className="carousel-controls">
        <button onClick={prevSlide}>&lt;</button>
        <button onClick={nextSlide}>&gt;</button>
      </div>
    </section>
  );
};

export default TeamSection;
